export const HIDDENFAULTS_TOKEN = 'ppi.se.jwt'
export const HIDDENFAULTS_REFRESH = 'ppi.se.refresh'